import "@babel/polyfill";
import Vue from "vue";
import store from "./store";
import axios from "./modules/axios";
import "@/assets/style/style.scss";
import AOS from "aos";
import InstantSearch from "vue-instantsearch";

Vue.use(InstantSearch);

//rias
import "lazysizes/plugins/rias/ls.rias.min";
//bg
import "lazysizes/plugins/bgset/ls.bgset.min.js";
// support of respimg on edge/ie
import "lazysizes/plugins/respimg/ls.respimg.min.js";

import addToCart from "./components/add-to-cart.vue";
import cart from "./components/cart.vue";
import vdrawer from "./components/drawer/index.vue";
import heroslider from "./components/heroslider.vue";
import featured from "./components/featured-collection.vue";
import search from "./components/search.vue";
import product from "./components/product.vue";
import excerpt from "./components/excerpt.vue";
import modal from "./components/modal.vue";
import accordion from "./components/accordion.vue";
import editorialslider from "./components/editorial-slider.vue";
import flowForm from "./components/flow-form/index.vue";
import vblog from "./components/blog-slider.vue";
import instafeed from "./components/insta-feed.vue";
import bigeditorial from "./components/big-editorial-slider.vue";
import herovideo from "./components/video-background.vue";
import vmenu from "./components/menu/index.vue";
import scrollBtn from "./components/scrollBtn.vue";
import productCard from "./components/product-card.vue";
import basicForm from "./components/product-forms/basic-form.vue";
import variantForm from "./components/product-forms/variant-form.vue";
import cookieBanner from "./components/cookie-banner.vue";
import slideInContact from "./components/slide-in-contact.vue";
import fbShare from "./components/facebook-share.vue";
import vNewsletter from "./components/newsletter.vue";

AOS.init();
Vue.use(InstantSearch);

new Vue({
	el: "#app",
	components: {
		addToCart,
		cart,
		vdrawer,
		heroslider,
		featured,
		search,
		product,
		excerpt,
		modal,
		accordion,
		editorialslider,
		flowForm,
		vblog,
		instafeed,
		bigeditorial,
		herovideo,
		vmenu,
		scrollBtn,
		productCard,
		basicForm,
		variantForm,
		cookieBanner,
		slideInContact,
		fbShare,
		vNewsletter
	},
	store,
	created() {
		Vue.prototype.$translations = window.shop.translations;
		Vue.prototype.$settings = window.shop.settings;
		Vue.prototype.$formatMoney = (amount) => {
			return window.Shopify.formatMoney(amount);
		};
	}
});
